export default __webpack_public_path__ + "static/media/discord_png.5332ea24.gif";